<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
        {{ isEditMode ? 'Edit' : 'Add' }} Recurring Load
    </div>
    <button mat-icon-button class="close-btn" (click)="closeModal()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<form [formGroup]="recurrLoadForm" (ngSubmit)="saveRecurringLoad()" class="form-grid">
    <mat-dialog-content>
        <div class="form-grid-row">
            <!-- Row 1: Recurr Type and Weekdays -->
            <mat-form-field appearance="outline">
                <mat-label>Recurring Type</mat-label>
                <mat-select formControlName="recur_type" (selectionChange)="onRecurTypeChange()">
                    <mat-option>-- Recurring Type --</mat-option>
                    <mat-option *ngFor="let item of recurTypeOptions()" [value]="item.id">{{ item.name }}</mat-option>
                </mat-select>
                <mat-error
                    *ngIf="recurrLoadForm.get('recur_type')?.hasError('required') && recurrLoadForm.get('recur_type')?.touched">
                    Recurring Type is required
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-grid-row">
            <mat-form-field appearance="outline">
                <mat-label>Weekdays</mat-label>
                <mat-select formControlName="weekdaysArray" multiple placeholder="- Weekdays -">
                    <mat-option *ngFor="let item of weekdayOptions()" [value]="item.name">{{ item.name }}</mat-option>
                </mat-select>
                <mat-error
                    *ngIf="recurrLoadForm.get('weekdaysArray')?.hasError('required') && recurrLoadForm.get('weekdaysArray')?.touched">
                    Weekdays is required
                </mat-error>
            </mat-form-field>
        </div>
          <!-- Row 2: No of Loads -->
        <div class="form-grid-row">          
            <mat-form-field appearance="outline">
                <mat-label>No of Loads</mat-label>
                <mat-select formControlName="NoOfRecurrings">
                    <mat-option *ngFor="let item of noOfLoadsOptions" [value]="item.id">{{ item.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
          <!-- Row 3: Month Day Checkbox and Input (Side-by-Side) -->
        <div class="form-grid-row">          
            <mat-checkbox formControlName="monthDayChecked" (change)="onMonthDayChange()" class="mb-2">
                Month Day <span class="text-red-600">*</span>
            </mat-checkbox>
            <mat-form-field appearance="outline">
                <mat-label>Month Day</mat-label>

                <input matInput type="number" [formControl]="monthDayControl" placeholder="Enter Month Day" [min]="1"
                    [max]="31" class="text-right">
                <mat-error
                    *ngIf="recurrLoadForm.get('monthDay')?.hasError('min') || recurrLoadForm.get('monthDay')?.hasError('max')">
                    Must be between 1 and 31
                </mat-error>
            </mat-form-field>
        </div>
         <!-- Row 4: Day Sequence -->
        <div class="form-grid-row">           
            <mat-form-field appearance="outline">
                <mat-label>Day Sequence <span class="text-red-600">*</span></mat-label>
                <mat-select formControlName="daySequence" [required]="isDaySequenceRequired()">
                    <mat-option *ngFor="let item of daySequenceOptions()" [value]="item.id">{{ item.name }}</mat-option>
                </mat-select>
                <mat-error
                    *ngIf="recurrLoadForm.get('daySequence')?.hasError('required') && recurrLoadForm.get('daySequence')?.touched">
                    Day Sequence is required
                </mat-error>
            </mat-form-field>
        </div>
         <!-- Row 5: Disposal Site -->
        <div class="form-grid-row">           
            <mat-form-field appearance="outline" class="sm:col-span-2 w-full">
                <mat-label>Disposal Site</mat-label>
                <mat-select formControlName="disposalSiteID" (selectionChange)="onRecurrLoadSiteChange()"
                    placeholder="Select Disposal Site">
                    <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                        <input #disposalSiteSearchInput matInput placeholder="Search Disposal Site..."
                            (input)="filterDisposalSites($event)" class="mat-select-search-input"
                            aria-label="Search Disposal Site" (keydown)="$event.stopPropagation();" />
                        <mat-icon class="mat-select-search-icon">search</mat-icon>
                    </div>
                    <mat-option *ngFor="let site of filteredDisposalSites()" [value]="site.sid">{{ site.siteName
                        }}</mat-option>
                </mat-select>
                <mat-error
                    *ngIf="recurrLoadForm.get('disposalSiteID')?.hasError('required') && recurrLoadForm.get('disposalSiteID')?.touched">
                    Disposal Site is required
                </mat-error>
            </mat-form-field>
        </div>
         <!-- Row 6: Tank -->
        <div class="form-grid-row">           
            <mat-form-field appearance="outline" class="sm:col-span-2 w-full">
                <mat-label>Tank</mat-label>
                <mat-select formControlName="tankID">
                    <mat-option>-- Select Tank --</mat-option>
                    <mat-option *ngFor="let tank of tankOptions()" [value]="tank.tankID">{{ tank.tankName
                        }}</mat-option>
                </mat-select>
                <mat-error
                    *ngIf="recurrLoadForm.get('tankID')?.hasError('required') && recurrLoadForm.get('tankID')?.touched">
                    Tank is required
                </mat-error>
            </mat-form-field>
        </div>
    </mat-dialog-content>

    <!-- Modal Footer -->
    <mat-dialog-actions align="end" class="dialog-footer">
        <button data-testid="btnClose" mat-raised-button color="primary" type="button" (click)="closeModal()">
            Cancel
        </button>
        @if(canSave){
            <button data-testid="btnSave" mat-raised-button color="primary" type="submit">
                Save
            </button>
        }
    </mat-dialog-actions>
</form>